import React, { useEffect, useState } from "react";
import './blog.css';
import Carousel from 'react-bootstrap/Carousel'
import Header from '../../components/header/header.component';
import Footer from '../../components/footer/footer.component';
import { Link } from "react-router-dom";
// import sliderImg from '../../assets/images/Placeholder.png';
// import sliderImg1 from '../../assets/images/Placeholder3.png';
// import sliderImg2 from '../../assets/images/Placeholder1.png';
// import sliderImg3 from '../../assets/images/Placeholder3.png';
import { apiURL } from '../../configs'

const BlogPage = () => {
  const [blogs, setBlogs] = useState([])
  useEffect(() => {
    window.scrollTo(0, 0);
    getBlogs()
  }, [])

  const getBlogs = () => {
    fetch(apiURL + 'blogs/all_blogs')
      .then(response => response.json())
      .then(data => {
        console.log('data', data)
        if (data.success) {
          setBlogs(data.blogs);
        }
      });
  }

  return (
    <>
      <div className="header2">
        <Header />
      </div>
      <Carousel className="arrow_carousel contentStyle">
        <Carousel.Item className="carousel_bg_img">
          {/* <img src={sliderImg} style={{ width: "100%" }}></img> */}

        </Carousel.Item>
        <Carousel.Item className="carousel_bg_img_1">
          {/* <img src={sliderImg1} style={{ width: "100%" }}></img> */}

        </Carousel.Item>
        <Carousel.Item className="carousel_bg_img_2">
          {/* <img src={sliderImg2} style={{ width: "100%" }}></img> */}

        </Carousel.Item>
        <Carousel.Item className="carousel_bg_img_3">
          {/* <img src={sliderImg3} style={{ width: "100%" }}></img> */}

        </Carousel.Item>
      </Carousel>
      {/* <div className="container-fluid hero_blog_search">
        <div className="row">
          <div className="col-12 col-lg-12 col-xl-12">
            <div className="container_setting pl-0 pr-0">
              <div className="input-group mr-3" style={{ width: "100%" }}>
                <div className="input-group-prepend">
                  <button type="submit" className="btn btn_color_search">
                    <i className="fa fa-search" />
                  </button>
                </div>
                <input
                  type="search"
                  placeholder="SEARCH"
                  className="form-control input_search_bar"
                />
              </div>
            
            </div>
          </div>
        </div>
      </div> */}
      {/* <div className="container_setting hero_blog_section">
        <div className="first_blog_section">
          <div style={{ position: "relative" }}>
            <img style={{ width: "100%"}} src={require("../../assets/images/blogclip.png")}></img>
            <div className="centered">
              <img src={require("../../assets/images/imgicon.svg")}></img>
            </div>
          </div>
          <h1>BE THE ONE TO STAND OUT IN THE CROWED</h1>
          <p className="tag_line_blog">JANUARY 16,2016</p>
          <p className="tag_line_blog_description">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamcos laboris nisis ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore egiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id it laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore ut labore et dolore now is the great working with travlling magnam aliquam quaerat voluptatem.</p>
          <Link to="/blogdetail" className="text-decoration-none">
            <button className="read_button_blog btn btn-lg d-block ml-auto mr-auto" type="button">
              Read More
            </button>
          </Link>
        </div>
      </div> */}
    
      <div className="container_setting hero_blog_section1 mt-5">
        <div className="row">
          {blogs.length && blogs.map((blog, i) => {
            return (
              <div className="col-12 col-lg-6 col-xl-6 my-3" key={i}>
                <Link to={`/blog/${blog.id}`} className="text-decoration-none">
                <div className="first_blog_section first_blog_section_margin">
                  <img src={blog.images[0].image} style={{ width: "100%", height: "300px" }} />
                  <h1 className="tag_line_h1"> {blog.title}</h1>
                  {/* <p className="tag_line_blog">JANUARY 16,2016</p> */}
                  {/* <p className="tag_line_blog_description">   {blog.description ? blog.description.slice(0, 200) + '...' : ''}</p> */}
                  {/* <Link to={`/blog/${blog.id}`} className="text-decoration-none">
                    <button className="read_button_blog btn btn-lg d-block ml-auto mr-auto" type="button">
                      Read More
               </button>
                  </Link> */}
                </div>
                </Link>
              </div>)
          })}

        </div>
      </div>

      <Footer />
    </>
  )
}
export default BlogPage;

